function adjustSectionFive() {
    const inner = document.querySelector('.section-home-section-five__inner');
    const img   = document.querySelector('.section-home-section-five__image');
    if (!inner || !img) return;

    // Reset before recalculating
    inner.style.paddingBottom = '';

    const innerRect = inner.getBoundingClientRect();
    const imgRect   = img.getBoundingClientRect();
    const overflow  = imgRect.bottom - innerRect.bottom;

    if (overflow > 0) {
        const currentPb = parseFloat(getComputedStyle(inner).paddingBottom) || 0;
        inner.style.paddingBottom = (currentPb + overflow) + 'px';
    }
}

const img = document.querySelector('.section-home-section-five__image');
if (img) {
    if (img.complete) {
        adjustSectionFive();
    } else {
        img.addEventListener('load', adjustSectionFive);
    }
    window.addEventListener('resize', adjustSectionFive);
}
